(() => {
  class BackToTop extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('button');
    }
    connectedCallback() {
      this.handleScroll = this.handleScroll.bind(this);
      window.addEventListener('scroll', this.handleScroll);
      this.handleScroll();
      
      this.button.addEventListener('click', () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }

    handleScroll() {
      this.classList.toggle('is-visible', window.scrollY > 300);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScroll);
    }
  }

  if (!customElements.get('back-to-top')) {
    customElements.define('back-to-top', BackToTop);
  }
})()